<template>
  <div class="dashboard">
    <div class="container-fluid pt-4 pb-4">
      <h2 class="h4 fw-medium mb-4">{{ $t("__dashboard") }}</h2>
      <div class="mb-3">
        <span></span>
        {{ $t("__activeDevice") }}：
        <span>{{ onlineDeviceCount }}</span> /
        {{ $t("__allDevice") }}：
        <span>{{ allDeviceCount }}</span>
      </div>
      <div class="mb-3">
        <button class="btn btn-outline-primary btn-sm me-2" @click="openTransferModal()">
          <i class="bi bi-arrow-left-right"></i> 住民換床
        </button>
        <button
          class="btn btn-outline-warning btn-sm"
          :disabled="forceReloading"
          @click="triggerForceReload()"
        >
          <span v-if="forceReloading" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="bi bi-arrow-clockwise"></i> 重新整理前端
        </button>
      </div>
      <div v-if="allAgencys" class="mb-3">
        <label class="typo__label mb-2">{{ $t('__chooseAnAgency') }}</label>
        <multiselect
          v-model="searchAgency"
          :options="allAgencys"
          :preserve-search="true"
          label="id"
          track-by="id"
          :placeholder="$t('__agencyName') + ' / ' + $t('__codeName')"
        >
          <template slot="singleLabel" slot-scope="props">
            {{ props.option.name + " / " + props.option.codename }}
          </template>
          <template slot="option" slot-scope="props">
            {{ props.option.name + " / " + props.option.codename }}
          </template>
        </multiselect>
      </div>

      <div class="row" v-if="data">
        <div class="col-lg-6">
          <div class="card mb-4">
            <div class="card-body">
              <h3 class="h5 fw-medium mb-4">{{ $t("__machineHealth") }}</h3>
              <BarChart
                type="device"
                v-if="data && data.device && data.device.count && (Object.keys(data.device.list).length > 0 || Object.keys(data.device.state).length > 0)"
                :keyName="[$t('__quantity'), $t('__codeName')]"
                :yKey="['02', '03', '04', '05', '06']"
                :svgPaddingX="svgPaddingX"
                :svgPaddingY="svgPaddingY"
                :data="filterDeviceData"
                :deviceAllCount="data.device.count"
              />
              <p v-else class="text-center">{{ $t("__notData") }}</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card mb-4">
            <div class="card-body">
              <h3 class="h5 fw-medium mb-4">
                {{ $t("__machineNetworkAbnormal") }}
              </h3>
              <BarChart
                type="network"
                :keyName="[$t('__quantity'), $t('__offlineAbbreviation')]"
                v-if="data && data.network && data.network.count"
                :yKey="networkYKey"
                :svgPaddingX="svgPaddingX"
                :svgPaddingY="svgPaddingY"
                :data="data.network"
                :deviceAllCount="data.device.count"
              />
              <p v-else class="text-center">
                {{ $t("__noMachineNetworkAbnormal") }}
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-6">
          <div class="card mb-4">
            <div class="card-body">
              <h3 class="h5 fw-medium mb-4">{{ $t("__errorNotification") }}</h3>
              <div class="text-center mb-3">
                <div class="custom-tab-check d-inline-flex">
                  <div class="form-check">
                    <input
                      v-model="report_range"
                      class="form-check-input"
                      type="radio"
                      name="report_range"
                      :value="null"
                      id="now"
                    />
                    <label class="form-check-label fw-medium" for="now">{{
                      $t("__currentStatistics")
                    }}</label>
                  </div>
                  <div class="form-check">
                    <input
                      v-model="report_range"
                      class="form-check-input"
                      type="radio"
                      name="report_range"
                      value="week"
                      id="week"
                    />
                    <label class="form-check-label fw-medium" for="week">{{
                      $t("__statisticsForTheWeek")
                    }}</label>
                  </div>
                  <div class="form-check">
                    <input
                      v-model="report_range"
                      class="form-check-input"
                      type="radio"
                      name="report_range"
                      value="month"
                      id="month"
                    />
                    <label class="form-check-label fw-medium" for="month">{{
                      $t("__statisticsForTheMonth")
                    }}</label>
                  </div>
                </div>
              </div>
              <StackedBarChart
                type="network"
                :keyName="$t('__quantity')"
                v-if="data && data.report && data.report.count"
                :yKey="['1', '2', '3', '4', '5']"
                :svgPaddingX="svgPaddingX"
                :svgPaddingY="svgPaddingY"
                :data="data.report"
                :chartColor="chartColor.report"
              />
              <p v-else class="text-center">{{ $t("__notData") }}</p>
            </div>
          </div>
        </div> -->
      </div>
      <div v-else>
        {{ $t('__pleaseSelectAnAgency') }}
      </div>
    </div>

    <!-- 住民換床 Modal -->
    <div class="modal fade cms-style" tabindex="-1" ref="transferModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-medium">住民換床（更換裝置）</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div v-if="transferResult" class="alert alert-success">
              <strong>換床成功！</strong><br>
              住民「{{ transferResult.resident_name }}」已從
              <template v-if="transferResult.old_device">
                裝置 {{ transferResult.old_device.serial_id }}
              </template>
              <template v-else>（無裝置）</template>
              換到裝置 {{ transferResult.new_device.serial_id }}
              <template v-if="transferResult.line_groups_updated > 0">
                <br>已同步更新 {{ transferResult.line_groups_updated }} 個 LINE 群組綁定
              </template>
            </div>
            <div v-if="transferError" class="alert alert-danger">
              {{ transferError }}
            </div>
            <div class="mb-3">
              <label class="form-label fw-medium">選擇機構 <span class="text-danger">*</span></label>
              <multiselect
                v-model="transferForm.agency"
                :options="allAgencys || []"
                :preserve-search="true"
                label="name"
                track-by="id"
                placeholder="搜尋機構名稱 / 代號"
                @input="onTransferAgencyChange"
              >
                <template slot="singleLabel" slot-scope="props">
                  {{ props.option.name + " / " + props.option.codename }}
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name + " / " + props.option.codename }}
                </template>
              </multiselect>
            </div>
            <div class="mb-3">
              <label class="form-label fw-medium">選擇住民 <span class="text-danger">*</span></label>
              <multiselect
                v-model="transferForm.resident"
                :options="transferResidents"
                :preserve-search="true"
                :disabled="!transferForm.agency"
                label="name"
                track-by="id"
                placeholder="搜尋住民姓名"
                :loading="transferResidentsLoading"
              >
                <template slot="singleLabel" slot-scope="props">
                  {{ props.option.name }}
                  <template v-if="props.option.device">
                    <span class="text-muted">（目前裝置：{{ props.option.device.serial_id }}）</span>
                  </template>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                  <template v-if="props.option.device">
                    <span class="text-muted ms-2">{{ props.option.device.serial_id }}</span>
                  </template>
                  <template v-else>
                    <span class="text-warning ms-2">（無裝置）</span>
                  </template>
                </template>
              </multiselect>
            </div>
            <div class="mb-3">
              <label class="form-label fw-medium">新裝置序號 <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model.trim="transferForm.newSerialId"
                placeholder="輸入目標裝置的 Serial ID"
                :disabled="!transferForm.resident"
              >
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
              {{ $t("__cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!canSubmitTransfer || transferSubmitting"
              @click="submitTransfer"
            >
              <span v-if="transferSubmitting" class="spinner-border spinner-border-sm me-1"></span>
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/chart/BarChart.vue";
import StackedBarChart from "@/components/chart/StackedBarChart.vue";
import { mapState, mapMutations } from "vuex";
import { overview } from "@/http/api/overview.js";
import i18n from "@/lang/lang.js";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { agency } from "@/http/api/agency.js";
import { device } from "@/http/api/device.js";
import { Modal } from "bootstrap";

export default {
  name: "Dashboard",
  components: { BarChart, StackedBarChart, Multiselect },
  data() {
    return {
      data: null,
      report_range: null, // "month", "week"
      svgPaddingX: 90,
      svgPaddingY: 60,
      searchAgency: null,
      allAgencys: null,
      allDeviceCount: null,
      offlineDeviceCount: null,
      chartColor: {
        report: {
          processed: "#48EBDC",
          processing: "#FCAE70",
        },
      },
      networkYKey: ["3day", "1day", "12hour", "1hour", "30min", "10min"],
      transferModalInstance: null,
      transferForm: {
        agency: null,
        resident: null,
        newSerialId: '',
      },
      transferResidents: [],
      transferResidentsLoading: false,
      transferSubmitting: false,
      transferResult: null,
      transferError: null,
      forceReloading: false,
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    filterDeviceData() {
      // 排除 01 狀態
      var newData;
      if (this.data && this.data.device) {
        newData = this.data.device;
        if (Object.prototype.hasOwnProperty.call(newData.state, "01")) {
          delete newData.state["01"];
        }
      }
      return newData;
    },
    filterAgency() {
      const vm = this;
      const filterAgency = [];
      if (vm.searchAgency) {
        filterAgency.push(vm.searchAgency.id);
      }
      return filterAgency;
    },
    onlineDeviceCount() {
      const vm = this;
      if (vm.allDeviceCount === null || vm.offlineDeviceCount === null){
        return i18n.t("__loading")
      }
      return vm.allDeviceCount - vm.offlineDeviceCount
    },
    canSubmitTransfer() {
      return this.transferForm.agency
        && this.transferForm.resident
        && this.transferForm.newSerialId.length > 0;
    },
  },
  watch: {
    report_range() {
      this.getOverview();
    },
    userInfo(data) {
      if (data) {
        this.initEvent ()
      }
    },
    searchAgency(data) {
      if (data) {
        this.getOverview();
      } else {
        this.data = null
      }
    },
  },
  methods: {
    ...mapMutations([
      "Loading",
      "Loaded",
      "AlertsInfo",
      "Alerted",
    ]),
    initEvent (){
      const vm = this;
      vm.getAllOverview();
      vm.getAllAgency();
    },
    getAllOverview () {
      const vm = this;
      overview.get(vm.token).then((res) => {
        if (res.status <= 201) {
          vm.allDeviceCount = res.data.data.device.count
          vm.offlineDeviceCount = res.data.data.network.count
        } else {
          vm.AlertsInfo({
            state: "error",
            title: i18n.t("__error"),
            info: res.data.errors.toString(),
          });
          vm.Alerted();
        }
        vm.Loaded();
      });
    },
    getOverview() {
      const vm = this;
      var config = Object.assign({}, vm.token);
      config.params = {};
      if (vm.report_range) {
        config.params.report_range = vm.report_range;
      }
      if (vm.filterAgency.length) {
        config.params.agency_ids = vm.filterAgency;
      }

      vm.Loading();
      overview.get(config).then((res) => {
        if (res.status <= 201) {
          vm.data = res.data.data;
          vm.allDeviceCount = res.data.data.device.count
          vm.offlineDeviceCount = res.data.data.network.count
        } else {
          vm.AlertsInfo({
            state: "error",
            title: i18n.t("__error"),
            info: res.data.errors.toString(),
          });
          vm.Alerted();
        }
        vm.Loaded();
      });
    },
    getAllAgency() {
      const vm = this;
      agency.get("", this.token).then((res) => {
        if (res.status <= 201 && res.data.status === "success") {
          vm.allAgencys = res.data.data.filter(
            agency => {
              return agency.status === 1
            }
          );
        }
      });
    },
    openTransferModal() {
      const vm = this;
      vm.transferForm = { agency: null, resident: null, newSerialId: '' };
      vm.transferResidents = [];
      vm.transferResult = null;
      vm.transferError = null;
      vm.transferSubmitting = false;
      if (!vm.transferModalInstance) {
        vm.transferModalInstance = new Modal(vm.$refs.transferModal);
      }
      vm.transferModalInstance.show();
    },
    onTransferAgencyChange(selected) {
      const vm = this;
      vm.transferForm.resident = null;
      vm.transferForm.newSerialId = '';
      vm.transferResidents = [];
      vm.transferResult = null;
      vm.transferError = null;
      if (!selected) return;
      vm.transferResidentsLoading = true;
      agency.getResidents(selected.id, vm.token).then((res) => {
        if (res.data && res.data.data) {
          vm.transferResidents = res.data.data;
        }
        vm.transferResidentsLoading = false;
      }).catch(() => {
        vm.transferResidentsLoading = false;
      });
    },
    triggerForceReload() {
      const vm = this;
      if (!confirm('確定要通知所有機構的前端重新整理嗎？')) return;
      vm.forceReloading = true;
      const payload = {};
      device.forceReload(payload, vm.token).then((res) => {
        if (res.data && res.data.status === 'success') {
          const count = res.data.data.agencies_notified;
          vm.AlertsInfo({
            state: 'success',
            title: i18n.t('__success'),
            info: '已通知 ' + count + ' 個機構的前端重新整理',
          });
          vm.Alerted();
        } else {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: res.data.errMsg || '操作失敗',
          });
          vm.Alerted();
        }
        vm.forceReloading = false;
      }).catch(() => {
        vm.forceReloading = false;
      });
    },
    submitTransfer() {
      const vm = this;
      vm.transferSubmitting = true;
      vm.transferResult = null;
      vm.transferError = null;
      const payload = {
        agency_id: vm.transferForm.agency.id,
        resident_id: vm.transferForm.resident.id,
        new_serial_id: vm.transferForm.newSerialId,
      };
      device.transferResident(payload, vm.token).then((res) => {
        if (res.data && res.data.status === 'success') {
          vm.transferResult = res.data.data;
          vm.transferForm = { agency: null, resident: null, newSerialId: '' };
          vm.transferResidents = [];
        } else {
          vm.transferError = res.data.errMsg || '操作失敗';
        }
        vm.transferSubmitting = false;
      }).catch((err) => {
        vm.transferError = (err.response && err.response.data && err.response.data.errMsg) || '伺服器錯誤';
        vm.transferSubmitting = false;
      });
    },
  },
  created() {},
  mounted() {
    const vm = this
    if (vm.userInfo) {
      vm.initEvent ()
    }
  },
};
</script>

<style  lang="scss">
.multiselect__option--highlight {
  background-color: $primary;
  &::after {
    background-color: $primary;
  }
}
</style>
